import * as ent from '@/entities';

export class CompanyFeeEditModel {
    public dirty: boolean = false;
    public inProgress: boolean = false;
    public companyFee: ent.ICompanyFeeModel;
    public defaultType: ent.ISiteTypeListModel;

    constructor(
        companyFee: ent.ICompanyFeeModel,
        defaultType: ent.ISiteTypeDetailModel
    ) {
        this.companyFee = companyFee;
        this.defaultType = defaultType;
    }

    get typeId() {
        return this.companyFee.typeId;
    }

    get companyId() {
        return this.companyFee.companyId;
    }

    get officeName() {
        return this.companyFee.officeName;
    }

    get enable() {
        return this.companyFee.enable;
    }

    set enable(val: boolean) {
        this.companyFee.enable = val;
    }

    get payout() {
        return this.actualSource.payout;
    }

    set payout(val: number) {
        this.actualSource.payout = val;
    }

    get earning() {
        return this.actualSource.earning;
    }

    set earning(val: number) {
        this.actualSource.earning = val;
    }

    get lpp() {
        return this.actualSource.lpp;
    }

    set lpp(val: number) {
        this.actualSource.lpp = val;
    }

    get bonusPayout() {
        return this.actualSource.bonusPayout;
    }

    set bonusPayout(val: number) {
        this.actualSource.bonusPayout = val;
    }

    get bonusEarning() {
        return this.actualSource.bonusEarning;
    }

    set bonusEarning(val: number) {
        this.actualSource.bonusEarning = val;
    }

    get bonusLpp() {
        return this.actualSource.bonusLpp;
    }

    set bonusLpp(val: number) {
        this.actualSource.bonusLpp = val;
    }

    public getModelToUpdate(): ent.ICompanyFeeUpdateModel {
        return {
            typeId: this.typeId,
            companyId: this.companyId,
            enable: this.enable,
            earning: this.earning,
            payout: this.payout,
            lpp: this.lpp,
            bonusPayout: this.bonusPayout,
            bonusEarning: this.bonusEarning,
            bonusLpp: this.bonusLpp,
        };
    }

    private get actualSource() {
        return this.enable ? this.companyFee : this.defaultType;
    }
}
